export const menuEventsConfig = {
    parentSelector: 'body',
    events: {
        // Mobile menu hamburger open
        hamburgerOpen: {
            selector: 'summary.header__icon--menu.header__icon--summary',
            event: {
                event: 'menu',
                component: 'hamburger',
                element: 'button',
                action: 'open',
                trigger: 'click',
                condition: (element) => !element.closest('details')?.hasAttribute('open')
            }
        },

        // Mobile menu hamburger close
        hamburgerClose: {
            selector: 'summary.header__icon--menu.header__icon--summary[aria-expanded="true"]',
            event: {
                event: 'menu',
                component: 'hamburger',
                element: 'button',
                action: 'close',
                trigger: 'click'
            }
        },

        // Mobile menu accordion open/close
        menuAccordionToggle: {
            parentSelector: 'menu-drawer__navigation',
            selector: 'details.menu-drawer__menu-item > summary.menu-drawer__menu-item',
            event: {
                event: 'menu',
                component: 'menu',
                element: 'accordion',
                trigger: 'click',
                getDynamicData: (element) => {
                    const detailsElement = element.closest('details');
                    const isOpenAfterClick = detailsElement?.hasAttribute('open');
                    const action = isOpenAfterClick ? 'open' : 'close';
                    const fieldName = element.textContent.trim().replace(/\s*<svg.*?<\/svg>\s*/, '').trim();
                    
                    return {
                        action: action,
                        field_name: fieldName
                    };
                }
            }
        },

        // Mobile menu submenu close button
        submenuCloseButton: {
            selector: 'button.menu-drawer__close-button',
            event: {
                event: 'menu',
                component: 'menu',
                element: 'button',
                action: 'close',
                trigger: 'click',
                getDynamicData: (element) => {
                    const fieldName = element.textContent.trim().replace(/\s*<svg.*?<\/svg>\s*/, '').trim();
                    return {
                        field_name: fieldName
                    };
                }
            }
        },

        // Mobile menu link clicks
        menuLinkClick: {
            selector: 'a.menu-drawer__menu-item',
            event: {
                event: 'menu',
                component: 'menu',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    return {
                        link_text: element.textContent.trim(),
                        link_url: element.href
                    };
                }
            }
        },

        // Social media links in mobile menu
        menuSocialLinkClick: {
            selector: 'menu-drawer__utility-links .list-social__link',
            event: {
                event: 'menu',
                component: 'menu',
                element: 'icon',
                field: 'social',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    return {
                        link_url: element.href
                    };
                }
            }
        },

        // Desktop menu accordion open/close
        desktopMenuAccordionToggle: {
            selector: 'details.mega-menu > summary.header__menu-item',
            event: {
                event: 'menu',
                component: 'header',
                element: 'accordion',
                trigger: 'click',
                getDynamicData: (element) => {
                    const detailsElement = element.closest('details');
                    const isOpenAfterClick = detailsElement?.hasAttribute('open');
                    const action = isOpenAfterClick ? 'open' : 'close';
                    const fieldName = element.textContent.trim().replace(/\s*<svg.*?<\/svg>\s*/, '').trim();
                    
                    return {
                        action: action,
                        field_name: fieldName
                    };
                }
            }
        },

        // Desktop menu link clicks
        desktopMenuLinkClick: {
            selector: 'ul.header__submenu a.header__menu-item',
            event: {
                event: 'menu',
                component: 'header',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    return {
                        link_text: element.textContent.trim(),
                        link_url: element.href
                    };
                }
            }
        },

        // Desktop menu "Go to" link clicks
        desktopMenuGoToClick: {
            selector: 'li.header__goto-link a',
            event: {
                event: 'menu',
                component: 'header',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    return {
                        link_text: element.textContent.trim(),
                        link_url: element.href
                    };
                }
            }
        },

        // Account icon click
        accountIconClick: {
            selector: 'a.header__icon--account',
            event: {
                event: 'user_interaction',
                component: 'header',
                element: 'icon',
                field: 'login',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    return {
                        link_url: element.href
                    };
                }
            }
        },

        // Cart icon click
        cartIconClick: {
            selector: 'a.header__icon--cart',
            event: {
                event: 'user_interaction',
                component: 'header',
                element: 'icon',
                field: 'cart',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => {
                    return {
                        link_url: element.href
                    };
                }
            }
        },

        // Search icon click
        searchIconClick: {
            selector: 'summary.header__icon--search',
            event: {
                event: 'search',
                component: 'search_modal',
                element: 'modal',
                action: 'open',
                trigger: 'click'
            }
        }
    }
}; 